import compose from 'recompose/compose';
import branch from 'recompose/branch';
import renderComponent from 'recompose/renderComponent';

export default states =>
  compose(...states.map(state =>
    branch(state.when, renderComponent(state.render))
  ));
